////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const exportDatas = {
	postExportDatas: (filters = {}, url = '') => ({
		type: ActionsTypes.POST_EXPORT_DATAS,
		payload: {
			filters,
			url,
		},
	}),
	postExportDatasSuccess: (data) => ({
		type: ActionsTypes.POST_EXPORT_DATAS_SUCCESS,
		payload: {
			data,
		},
	}),
	postExportDatasFailure: (error) => ({
		type: ActionsTypes.POST_EXPORT_DATAS_FAILURE,
		payload: {
			error,
		},
	}),
}

export default exportDatas
